<nav>
  <ul class="pagination" *ngIf="paginationLength > 7;">
    <li class="page-item" [class.disabled]="pageCount === 1" [attr.tabindex]="currentPage === 1 ? -1 : ''">
      <a class="page-link" (click)="changePage(pageCount - 1)"><i class="fas fa-angle-left"></i></a>
    </li>
    <li class="page-item d-sm-down-none" [class.active]="page === pageCount" *ngFor="let page of beginningArray">
      <a class="page-link" (click)="changePage(page)">{{ page }}</a>
    </li>
    <li class="page-item d-sm-down-none" *ngIf="beginningArray.length === 1">
      <a class="page-link">...</a>
    </li>
    <li class="page-item d-sm-down-none" [class.active]="page === pageCount" *ngFor="let page of middleArray">
      <a class="page-link" (click)="changePage(page)">{{ page }}</a>
    </li>
    <li class="page-item d-sm-down-none" *ngIf="endingArray.length === 1">
      <a class="page-link">...</a>
    </li>
    <li class="page-item d-sm-down-none" [class.active]="page === pageCount" *ngFor="let page of endingArray">
      <a class="page-link" (click)="changePage(page)">{{ page }}</a>
    </li>
    <li class="page-item" [class.disabled]="pageCount === paginationLength" [attr.tabindex]="pageCount === paginationLength ? -1 : ''">
      <a class="page-link" (click)="changePage(pageCount + 1)"><i class="fas fa-angle-right"></i></a>
    </li>
  </ul>
  <ul class="pagination" *ngIf="paginationLength <= 7">
    <li class="page-item" [class.disabled]="pageCount === 1" [attr.tabindex]="pageCount === 1 ? -1 : ''">
      <a class="page-link" (click)="changePage(pageCount - 1)"><i class="fas fa-angle-left"></i></a>
    </li>
    <li class="page-item d-sm-down-none" [class.active]="page === pageCount" *ngFor="let page of pagesArray">
      <a class="page-link" (click)="changePage(page)">{{ page }}</a>
    </li>
    <li class="page-item" [class.disabled]="pageCount === paginationLength" [attr.tabindex]="pageCount === paginationLength ? -1 : ''">
      <a class="page-link" (click)="changePage(pageCount + 1)"><i class="fas fa-angle-right"></i></a>
    </li>
  </ul>
</nav>
